import React, { useEffect, useState } from "react";
import { firestore, signInWithGoogle } from "../firebase";
import { collection, addDoc, onSnapshot } from "firebase/firestore";
import EntryCard from "../components/EntryCard";
import useFirebaseAuthentication from "../utils/useFirebaseAuth";
import {
    Typography,
    TextField,
    Collapse,
    Fab,
    CircularProgress,
} from "@mui/material";
import moment from "moment";
import { useFormik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import CenterLayout from "../components/CenterLayout";

export default function Guestbook() {
    const authUser = useFirebaseAuthentication();
    const [entries, setEntries] = useState([]);
    const [newEntry, setNewEntry] = useState(false);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const unsubscribe = onSnapshot(
            collection(firestore, "guestbook"),
            (snapshot) => {
                setEntries(
                    snapshot.docs
                        .map((doc) => ({ ...doc.data(), id: doc.id }))
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                );
                setLoading(false);
            }
        );
        return () => unsubscribe();
    }, []);

    const formik = useFormik({
        initialValues: {
            text: "",
        },
        onSubmit: (values) => {
            setSubmitting(true);
            if (authUser) {
                const submitValues = {
                    ...values,
                    displayName: authUser.displayName,
                    avatarUrl: authUser.photoURL,
                    userId: authUser.uid,
                    date: moment().format("YYYY-MM-DD"),
                };

                addDoc(collection(firestore, "guestbook"), submitValues).then(
                    (docRef) => {
                        setNewEntry(false);
                        setSubmitting(false);
                        formik.resetForm();
                    }
                );
            }
        },
    });

    return (
        <CenterLayout>
            <h1 style={{ marginBottom: 16 }}>Gjestebok</h1>

            {authUser && (
                <Collapse in={newEntry} sx={{ width: 1 }}>
                    <EntryCard
                        name={authUser.displayName}
                        date={new Date()}
                        avatar={authUser.photoURL}
                        newEntry
                        setNewEntry={setNewEntry}
                        onSubmit={formik.handleSubmit}
                        disabled={formik.values.text.length === 0}
                    >
                        <TextField
                            id="text"
                            name="text"
                            sx={{ m: 0 }}
                            rows={5}
                            multiline
                            fullWidth
                            placeholder="Skriv i gjesteboken"
                            value={formik.values.text}
                            onChange={formik.handleChange}
                            disabled={submitting}
                        />
                    </EntryCard>
                </Collapse>
            )}
            {loading && <CircularProgress />}
            {entries &&
                entries.map((entry, index) => (
                    <EntryCard
                        key={index}
                        name={entry.displayName}
                        avatar={entry.avatarUrl}
                        date={entry.date}
                        entryId={entry.id}
                        currentUser={authUser?.uid === entry.userId}
                    >
                        <Typography sx={{ whiteSpace: "pre-wrap" }}>
                            {entry.text}
                        </Typography>
                    </EntryCard>
                ))}
            <Fab
                sx={{ position: "fixed", bottom: 16, right: 16 }}
                onClick={() =>
                    authUser ? setNewEntry(true) : signInWithGoogle()
                }
                variant="extended"
                color="primary"
            >
                Skriv innlegg
                <AddIcon sx={{ ml: 1 }} />
            </Fab>
        </CenterLayout>
    );
}
